import {
    GET_EXPENSE_CATEGORY,
    GET_EXPENSE_CATEGORY_SUCCESS,
    GET_EXPENSE_CATEGORY_FAIL,
    ADD_NEW_EXPENSE_CATEGORY,
    ADD_EXPENSE_CATEGORY_SUCCESS,
    ADD_EXPENSE_CATEGORY_FAIL,
    UPDATE_EXPENSE_CATEGORY,
    UPDATE_EXPENSE_CATEGORY_SUCCESS,
    UPDATE_EXPENSE_CATEGORY_FAIL,
    GET_EXPENSE_LIST,
    GET_EXPENSE_LIST_SUCCESS,
    GET_EXPENSE_LIST_FAIL,
    ADD_NEW_EXPENSE,
    ADD_EXPENSE_SUCCESS,
    ADD_EXPENSE_FAIL,
    UPDATE_EXPENSE,
    UPDATE_EXPENSE_SUCCESS,
    UPDATE_EXPENSE_FAIL,
  } from './actionTypes';
  
  // Action creators
  export const getExpenseCategory = () => ({
    type: GET_EXPENSE_CATEGORY,
  });
  
  export const getExpenseCategorySuccess = (data) => ({
    type: GET_EXPENSE_CATEGORY_SUCCESS,
    payload: data,
  });
  
  export const getExpenseCategoryFail = (error) => ({
    type: GET_EXPENSE_CATEGORY_FAIL,
    payload: error,
  });
  
  export const addNewExpenseCategory = (category) => {
    console.log('Attempting to add new expense category:', category);
    return {
      type: ADD_NEW_EXPENSE_CATEGORY,
      payload: category,
    };
  };
  export const addExpenseCategorySuccess = (data) => ({
    type: ADD_EXPENSE_CATEGORY_SUCCESS,
    payload: data,
  });
  
  export const addExpenseCategoryFail = (error) => ({
    type: ADD_EXPENSE_CATEGORY_FAIL,
    payload: error,
  });
  
  export const updateExpenseCategory = (category) => ({
    type: UPDATE_EXPENSE_CATEGORY,
    payload: category,
  });
  
  export const updateExpenseCategorySuccess = (data) => ({
    type: UPDATE_EXPENSE_CATEGORY_SUCCESS,
    payload: data,
  });
  
  export const updateExpenseCategoryFail = (error) => ({
    type: UPDATE_EXPENSE_CATEGORY_FAIL,
    payload: error,
  });
  
  export const getExpenseList = () => ({
    type: GET_EXPENSE_LIST,
  });
  
  export const getExpenseListSuccess = (data) => ({
    type: GET_EXPENSE_LIST_SUCCESS,
    payload: data,
  });
  
  export const getExpenseListFail = (error) => ({
    type: GET_EXPENSE_LIST_FAIL,
    payload: error,
  });
  
  export const addNewExpense = (expense) => ({
    type: ADD_NEW_EXPENSE,
    payload: expense,
  });
  
  export const addExpenseSuccess = (data) => ({
    type: ADD_EXPENSE_SUCCESS,
    payload: data,
  });
  
  export const addExpenseFail = (error) => ({
    type: ADD_EXPENSE_FAIL,
    payload: error,
  });
  
  export const updateExpense = (expense) => ({
    type: UPDATE_EXPENSE,
    payload: expense,
  });
  
  export const updateExpenseSuccess = (data) => ({
    type: UPDATE_EXPENSE_SUCCESS,
    payload: data,
  });
  
  export const updateExpenseFail = (error) => ({
    type: UPDATE_EXPENSE_FAIL,
    payload: error,
  });